import type { FaireProductEntity } from "../../entity_types/product";

export const p_ygvypm96z3: FaireProductEntity = {
  token: "p_ygvypm96z3",
  type: "product",
  name: "Having Me as a Daughter Candle - Mother's Day Gift",
  brandToken: "b_5q1kwycuyw",
  brandName: "CE Craft Co",
  imageUrl: "https://cdn.faire.com/fastly/3a7313565ca8837cb015f6ba87421fc14f0ba8f4c718378abbe68e98cae7f52a.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/0cdbd8c0fdbaf6f5693dfa479f47528efd1aa9e7440d017b3d0ad935d15f4e11.jpeg",
    "https://cdn.faire.com/fastly/cc73ee290858684a9afd738557812c49734de705f9d9d864b120d7f1e1b8ce71.jpeg",
    "https://cdn.faire.com/fastly/7589e8bd8a6a26940810c7dbe3f732a701f8c73d45e879040cb6712460807595.jpeg"
  ],
  priceDollars: 11.5,
  description: "Having Me As A Daughter is Really the Only Gift You Need candle is the perfect soy wax scented candle for any home! This candle is the funniest gift for your mom as a reminder that she already has the best gift she can have in you. The absolute perfect Mother's Day Gift for your shop!\n\nThis candle looks so cute in any home and is made with all natural soy wax and hand poured in small batches. This candle is nontoxic all natural soy wax and poured in small batches to ensure each one is perfect. Plus it comes in over 15 scents to make sure there is something for everyone!",
  tags: [],
  msrpDollars: 23,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:55:24.123Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
